export enum ThirdPartyAccessErrorCode {
  ConnectionAlreadyExists = 1,
  EmailAlreadyExists = 2,
  ProfessionalAccountBanned = 3,
  TooManyIncorrectAttempts = 6,
  InvitationNotFound = 14,
  ConnectionStateConflict = 15,
  ConnectionNotFound = 16,
  RelationshipNotFound = 17,
  MatchNotFound = 18,
  ProfessionalAccountInactive = 19,
  InvitationExpired = 29,
  ParentUserFtrRestricted = 31
}

export type SelectedClientUserId = string

export const selectedClientUserIdPattern = /^[1-9]\d*$/

export function toPositiveSafeInteger(value: unknown): number | null {
  if (typeof value === 'number') {
    return Number.isSafeInteger(value) && value > 0 ? value : null
  }

  if (typeof value !== 'string' || !selectedClientUserIdPattern.test(value)) {
    return null
  }

  const parsed = Number(value)
  return Number.isSafeInteger(parsed) ? parsed : null
}

export function isSelectedClientUserId(
  value: string
): value is SelectedClientUserId {
  return toPositiveSafeInteger(value) !== null
}

export type RestrictedReason =
  | 'MATCH_SUSPENDED'
  | 'MATCH_REVOKED'
  | 'SURFACE_RESTRICTED'
  | 'INVITATION_EXPIRED'
  | 'INVITATION_DENIED'
  | 'PROFESSIONAL_BANNED'
  | 'NO_ACTIVE_MATCH'
  | 'unknown'

export type SessionEndedReason =
  'expired' | 'revoked' | 'ended' | 'error' | 'banned' | 'inactive'

export interface ThirdPartyAccessErrorResponse {
  errorCode?: ThirdPartyAccessErrorCode | number
  message?: string
}

export function mapThirdPartyAccessErrorCodeToRestrictedReason(
  errorCode?: ThirdPartyAccessErrorCode | number | null
): RestrictedReason {
  // Bare 403 with no body = policy denial (no active unsuspended match)
  if (errorCode === undefined || errorCode === null) {
    return 'NO_ACTIVE_MATCH'
  }

  switch (errorCode) {
    case ThirdPartyAccessErrorCode.ProfessionalAccountBanned:
      return 'PROFESSIONAL_BANNED'
    case ThirdPartyAccessErrorCode.ProfessionalAccountInactive:
      return 'MATCH_SUSPENDED'
    case ThirdPartyAccessErrorCode.ParentUserFtrRestricted:
      return 'SURFACE_RESTRICTED'
    case ThirdPartyAccessErrorCode.ConnectionStateConflict:
      return 'MATCH_SUSPENDED'
    case ThirdPartyAccessErrorCode.InvitationExpired:
    case ThirdPartyAccessErrorCode.InvitationNotFound:
      return 'INVITATION_EXPIRED'
    case ThirdPartyAccessErrorCode.ConnectionNotFound:
    case ThirdPartyAccessErrorCode.RelationshipNotFound:
    case ThirdPartyAccessErrorCode.MatchNotFound:
      return 'NO_ACTIVE_MATCH'
    default:
      return 'unknown'
  }
}
